<template>
    <UiDialog
        :isVisible="dialogVisible"
        :width="33"
        :height="20"
        :useOverLay="true"
        @onClose="dialogCloseHandler"
    >
        <section class="beta-dialog-container">
            <header class="beta-header-container">
                <h6 class="sentence sentence__600 medium">Coming soon</h6>
            </header>
            <div class="beta-dialog-content">
                <p class="sentence sentence__400">
                    We look forward to seeing you soon.<br />
                    thank you.
                </p>
            </div>
            <footer class="beta-footer-container">
                <button
                    :class="[`btn-linear`, `closeBtn`, `sentence`, `sentence__600`]"
                    @click="dialogCloseHandler"
                >
                    Close
                </button>
            </footer>
        </section>
    </UiDialog>
</template>

<script setup>
import UiDialog from '@/components/ui/Dialog.vue'
import {defineProps , defineEmits} from 'vue';
const emit  = defineEmits(["closeDialog"]);

const props = defineProps({
    dialogVisible : Boolean,
});

const dialogCloseHandler = ({ isVisible=false }) => {
    emit("closeDialog", isVisible);
}

</script>


<style lang="scss" scoped>
@import '@/assets/scss/components/common/login/BetaPopup.scss';
@import "@/assets/scss/components/ui/dialog.scss";
</style>